import React, { Component } from 'react';
import axios from 'axios';
import FileUpload from './file-upload.component';
import config from '../config';

const BACKEND_URL = config.backend.host;

class ImageUpload extends Component {

  state = {
    IMG_FILE_MAX_SIZE_MB: null,
  }

  constructor(props){
    super(props);
    //TODO: Convert to use from Redux
    axios.get(BACKEND_URL + '/configuration')
    .then(res => this.setState({IMG_FILE_MAX_SIZE_MB: res.data[0].imgFileMaxSizeMB}))
    .catch(e => alert(`Error: ${e} | Response: ${e.response.data.message}`));
  }

  render(){
    
    return(
      <div>
        <FileUpload maxFileMb={this.IMG_FILE_MAX_SIZE_MB} fileType={'image/*'} {...this.props}>
          Upload Image
        </FileUpload>
      </div>
    );
  }
}

export default ImageUpload;